import { Typography } from 'antd';
import type { TitleProps } from 'antd/es/typography/Title';
import { observer } from '@formily/reactive-react';
import { useField } from '@formily/react';
import type { VoidField } from '@formily/core';
import { IComponentSchema } from '../../types';

export interface IFormTitleProps extends TitleProps {
  title?: string;
  visible?: boolean;
}

const FormTitle = observer(
  ({ schema }: { schema: IComponentSchema<IFormTitleProps> }) => {
    const field = useField<VoidField>();

    const componentProps =
      schema?.['x-component-props'] || field?.componentProps || {};

    const { title, visible, ...rest } = componentProps as IFormTitleProps;

    if (visible === false) return null;

    return <Typography.Title {...rest}>{String(title)}</Typography.Title>;
  }
);

export default FormTitle;
